import { JCRichText } from "@/components";
import { isFilled } from "@prismicio/helpers";
export const ServicePageContent = ({ slice: { primary }, className }) => (<div className={className}>
        {isFilled.title(primary.content_title) ? (<div className="mb-7.5">
                <JCRichText field={primary.content_title}/>
            </div>) : null}

        <JCRichText field={primary.content_rich_text}/>
    </div>);
